import { apiClient } from "@api/client";
import { request } from "@api/request";

/** A clinic role (e.g. "Front desk") — tasks can be assigned to one instead of a user. */
export interface ClinicRole {
  id: string;
  name: string;
}

export const rolesClient = {
  /** All roles in the clinic (GET /roles) — used to resolve uuids to names. */
  list: (): Promise<ClinicRole[]> =>
    request(() => apiClient.GET("/roles", {})).then((roles) =>
      roles.map((r) => ({ id: r.uuid, name: r.name })),
    ),
};
